import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IRoleContact } from '../../../main/webshop/info/webshop-info-data.service';
import { IContact } from '../../../../type_definitions/datatypes';
import * as _ from 'underscore';

type GetterValueFn<T> = (params:IAgContactInfoRendererParams) => T;

export interface IAgContactInfoRendererParams extends ICellRendererParams {
  getContact:GetterValueFn<IContact | IContact[]>;
  getRoleContact:GetterValueFn<IRoleContact | IRoleContact[]>;
  showTooltip?:boolean;
}

@Component({
  selector: 'ag-contact-info',
  template: `
    <div class="ag-contact-info-container" *ngFor="let roleContact of roleContacts">
      <contact-info [roleContact]="roleContact" [showTooltip]="params.showTooltip"></contact-info>  
    </div>
    
    <div class="ag-contact-info-container"  *ngFor="let contact of contacts">
      <contact-info [contact]="contact" [showTooltip]="params.showTooltip"></contact-info>
    </div>
  `,
  styleUrls: ['./ag-contact-info-renderer.scss']
})
export class AgContactInfoRendererComponent implements ICellRendererAngularComp {
  public params!:IAgContactInfoRendererParams;
  public roleContacts:IRoleContact[];
  public contacts:IContact[];

  public agInit(params:IAgContactInfoRendererParams):void {
    this.params = params;
    this.setContactData();
  }

  public refresh(params:IAgContactInfoRendererParams):boolean {
    this.params = params;
    this.setContactData();
    // As we have updated the params we return true to let AG Grid know we have handled the refresh.
    // So AG Grid will not recreate the cell renderer from scratch.
    return true;
  }

  private setContactData():void {
    if (this.params.getContact) {
      const contacts:IContact | IContact[] = this.params.getContact(this.params);

      if (_.isArray(contacts)) {
        this.contacts = contacts;
      } else {
        this.contacts = [contacts];
      }
    }

    if (this.params.getRoleContact) {
      const roleContacts:IRoleContact | IRoleContact[] = this.params.getRoleContact(this.params);

      if (_.isArray(roleContacts)) {
        this.roleContacts = roleContacts;
      } else {
        this.roleContacts = [roleContacts];
      }
    }
  }
}